import React from 'react';

import { Col, Row } from 'antd';
import clsx from 'clsx';

export default function ResultatChiffre({
  label,
  value,
  className,
  isTotal = false,
}: {
  label: string;
  value: string;
  className?: string;
  isTotal?: boolean;
}) {
  return (
    <Row
      justify="space-between"
      align="middle"
      className={clsx('mb-8', className)}
    >
      <Col className="text-xl font-light">{label}</Col>
      <Col
        className={clsx(
          'text-3xl text-right',
          isTotal ? 'text-bleu-hellio font-bold' : '',
        )}
      >
        {value}
      </Col>
    </Row>
  );
}
